import {Helmet} from '@dr.pogodin/react-helmet';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';
import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {customerRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

export function Suppliers() {
  const navigate = useNavigate();

  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.warehouse.labels.suppliers'),
  };

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {institutions: ['SUPPLIER']}]),
    []
  );

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    if (isString(rowId) && actionKey === 'detail') {
      navigate(composePath(customerRoutes.detail, {params: {id: rowId}}));
    }
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.suppliers')} />
      <SettingsTemplate data-testid={testIds.settings.suppliers('template')} header={header}>
        <DmsDataGrid
          gridCode="customer"
          actionCallback={actionCallback}
          queryModifier={queryModifier}
        />
      </SettingsTemplate>
    </>
  );
}
